import React, {useCallback, useContext} from "react"
import Box, {Direction} from "./Box";
import {NavigationProps, ReactProps} from "../constants/Props";
import Title from "./Title";
import Button from "./Button";
import Icon from "./Icon";
import icons from "../css/Icon.module.css";
import styles from "../css/App.module.css"
import {formatI18nKeys, toI18N} from "../utils/I18n";
import {isMobile} from "react-device-detect";
import Text from "./Text";
import {GlobalContext} from "../constants/Providers";
import textStyles from "../css/Text.module.css";

interface Props extends ReactProps, NavigationProps {
    hideLogo?: boolean
    hideBack?: boolean
    isLoading?: boolean,
    hideNext?: boolean
    disabledNext?: boolean,
    subtitle: string,
    title: string,
    backgroundImage?: string,
    backgroundColor?: string,
    onBackgroundError?: () => void,
    onBackgroundIsLoad?: () => void,
    disabledKeyDown?: boolean,
}

export default (props: Props) => {

    const {
        subtitle,
        isLoading,
        onNext,
        title,
        backgroundImage,
        onBackgroundIsLoad,
        onBackgroundError,
        backgroundColor,
        disabledNext = false,
        hideLogo = false,
        hideBack = false,
        hideNext = false,
        children,
        disabledKeyDown
    } = props;

    // @ts-ignore
    const {reactAppVersion} = window;
    const hideIndication = title === reactAppVersion || title === "get_started_screen_header_title"
    // Context

    const {editingDeeplinkUrl, editDeeplinkIsExpired, fork} = useContext(GlobalContext);

    // Callbacks

    const handleOnKeyDown = useCallback(
        (event) => {
            if (event.key === "Enter" && onNext && !disabledNext && !disabledKeyDown) {
                onNext(event)
            }
        },
        [onNext, disabledKeyDown, disabledNext],
    );

    let style = {};
    style = {...style, height: '100%'};
    if (backgroundColor) style = {...style, backgroundColor};
    if (backgroundImage) style = {...style, backgroundImage: `url(${backgroundImage})`};
    if (editingDeeplinkUrl) style = {...style, paddingTop: 20};

    return (
        <Box onKeyDown={handleOnKeyDown} direction={Direction.Column} className={styles.screen} style={style}>

            {backgroundImage && <img
                style={{visibility: "hidden", position: "absolute"}}
                src={backgroundImage}
                onLoad={onBackgroundIsLoad}
                alt={''}
                onError={onBackgroundError}/>}

            {
                !hideLogo &&
                <Box direction={Direction.Clear} fullWidth className={styles.absoluteTop} topMargin={isMobile ? 6 : 42}>
                    {
                        !hideIndication &&
                        <Box center className={editingDeeplinkUrl ? styles.attention : undefined}>
                          <Text
                            size={12}>
                              {editingDeeplinkUrl ? `${formatI18nKeys('getting_started_editing_link', editingDeeplinkUrl)}${editDeeplinkIsExpired ? " (expired)" : ""}` : toI18N("creating_new_link")}
                            </Text>
                        </Box>
                    }
                    <Box leftMargin={10}>
                        <Title shrink
                               s
                               title={toI18N(title)}
                               subtitle={toI18N(subtitle)}/>
                    </Box>
                </Box>
            }

            {children}

            {
                !hideNext &&
                <Box center bottomMargin={70}>
                    <Button isLoading={isLoading} disabled={disabledNext} primary onClick={props.onNext}>
                        <Icon white name={icons.iconArrowRight}/>
                    </Button>
                </Box>
            }

            {
                !hideBack &&
                <Box shrink className={styles.absoluteBottom} leftMargin={20} bottomMargin={isMobile ? 20 : 30}>
                    <Button clear onClick={props.onBack}>
                        <Icon xl gray
                              name={icons.iconBack}/>
                    </Button>
                </Box>
            }

        </Box>
    );
}
